var React = require('react');

function DownChevron (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z","key":1})]);
}

DownChevron.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = DownChevron;

DownChevron.default = DownChevron;
